export const MAIN_CLASS_NAME = 'api-keys';
export const HEADER_CLASS_NAME = `${MAIN_CLASS_NAME}__header`;
export const REF_ID_CLASS_NAME = `${HEADER_CLASS_NAME}__ref-id`;
export const TABLE_CLASS_NAME = `${MAIN_CLASS_NAME}__table`;
export const ACCESS_CELL_CLASS_NAME = `${TABLE_CLASS_NAME}__access-cell`;
export const COPY_ID_BUTTON_CLASS_NAME = `${ACCESS_CELL_CLASS_NAME}__copy-id-button`;
export const ACTIONS_CLASS_NAME = `${TABLE_CLASS_NAME}__actions`;

export const ACTIONS_DATA_INDEX = 'actions';

export const X_TOKEN_LENGTH = 32;
export const X_TOKEN_VISIBLE_LENGTH = 5;
